import React, { useEffect } from 'react'

import { useI18n } from '@affiliate-cabinet/i18n'
import { Modal } from '@affstore-ds/uikit'

import { useModal } from '../../../../../hooks'
import { commonTranslationKeys } from '../../../../../translations/common.translationKeys'
import { ConfirmRedirectModalTranslationKeys } from './translations/ConfirmRedirectModal.translationKeys'

import { useNavigationContainer } from '../../../hooks/useNavigationContainer'

export const ConfirmRedirectModal = () => {
  const { i18n } = useI18n()

  const { allowRedirect, isRedirectConfirmationRequired, resetRedirectRestrictions } = useNavigationContainer()

  const { closeModal: closeConfirmLeaveModal, opened: openedConfirmLeaveModal, openModal: openConfirmLeaveModal } = useModal()

  const handleConfirmLeaveAccept = () => {
    allowRedirect()
    closeConfirmLeaveModal()
  }

  const handleConfirmLeaveCancel = () => {
    resetRedirectRestrictions()
    closeConfirmLeaveModal()
  }

  useEffect(() => {
    if (!isRedirectConfirmationRequired) {
      return
    }

    openConfirmLeaveModal()
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Need to keep dependencies stable
  }, [isRedirectConfirmationRequired])

  return (
    <Modal.Confirm
      data-testid="confirm-redirect-modal"
      hideOpenButton
      title={i18n.t(ConfirmRedirectModalTranslationKeys.confirmRedirectModalTitle)}
      buttonAcceptProperties={{
        children: i18n.t(commonTranslationKeys.commonLeave),
      }}
      buttonCancelProperties={{
        children: i18n.t(commonTranslationKeys.commonCancel),
      }}
      description={i18n.t(ConfirmRedirectModalTranslationKeys.confirmRedirectModalDescription)}
      elementVariant="warning"
      onAccept={handleConfirmLeaveAccept}
      onCancel={handleConfirmLeaveCancel}
      opened={openedConfirmLeaveModal}
      centered
      centeredContent
    />
  )
}
